import axios from 'axios';
import { message } from 'antd';
import { createAxiosInstance } from '&/utils/$axiosCreater';

function messageFn({ type, content, duration, key, isDestroy }) {
    if (isDestroy) {
        message.destroy(key);
    }
    message[type]({ content, duration, key });
}

const AXIOS = createAxiosInstance(
    axios,
    process.env.REACT_APP_BASE_URL,
    messageFn
);

export default AXIOS;
export { getConfirmation } from '&/utils/$axiosCreater';
